// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"168":"5c44676d","275":"5c44676d","283":"5c44676d","524":"5c44676d","757":"5c44676d"}[chunkId] + ".chunk.css";
};